import {
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { shallow } from 'zustand/shallow';
import moment from 'moment';
import { useNotificationStore } from '@/store/AppNotificationStore';
import { Urls, callApi } from '@/helpers/api-urls';
import useAxiosPost from '@/hooks/useAxiosPost';
import { useUserStore } from '@/store/Userdetails';
import { useTripProfileStore } from '@/store/TripProfileStore';
import NotificationMenu from '@shared/components/NotificationMenu';

const Notifications = () => {
  const { userData } = useUserStore(
    (state) => ({
      userData: state.userData,
    }),
    shallow
  );
  const { updateNotification, totalUnread, notifications } = useNotificationStore(
    (state) => ({
      updateNotification: state.updateNotification,
      notifications: state.notifications,
      totalUnread: state.totalUnread,
      primaryNotifications: state.primaryNotifications,
    }),
    shallow
  );

  const [ onlyUnread, setOnlyUnread ] = useState(false);

  const MarkAllAsReadHandler = async (ids = []) => {
    callApi
      .put(`${Urls.Contactnotifications}/visit`, {
        ids: ids,
        clearAll: ids.length ? false : true,
      })
      .then(({ responseCode }) => {
        if (responseCode === 200) {
          let totalU = 0;
          if (ids.length) {
            totalU = totalUnread - 1;
          }
          updateNotification({
            totalUnread: totalU,
            notifications: notifications.map((not) => {
              if (ids.length) {
                let idss = ids.indexOf(not.id) !== -1;
                if (idss) {
                  not.isVisited = true;
                }
              } else {
                not.isVisited = true;
              }
              return not;
            }),
            primaryNotifications: notifications.map((not) => {
              if (ids.length) {
                let idss = ids.indexOf(not.id) !== -1;
                if (idss) {
                  not.isVisited = true;
                }
              } else {
                not.isVisited = true;
              }
              return not;
            }),
          });
        }
      });
  };

  const { sendRequest: fetchNotifications, data: notificationsList } = useAxiosPost();
  useEffect(() => {
    if (notificationsList) {
      updateNotification({
        primaryNotifications: notificationsList.responseData.page.content,
        notifications: notificationsList.responseData.page.content,
        totalUnread: notificationsList?.responseData.unreadNotificationCount,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ notificationsList ]);

  const getNotifications = (read = false) => {
    let url = '';
    if (read) {
      url = `&isVisited=${!read}`;
    }
    fetchNotifications('get', `${Urls.Contactnotifications}/${userData.data.responseData.userData.user[0].id}?size=20&page=0${url}`, '');
  };
  const { setOpenTripProfileView, setTripId, setDataSourceIdForTrip  } = useTripProfileStore(
    (state) => ({
      setOpenTripProfileView: state.setOpenTripProfileView,
      setTripId: state.setTripId,
      setDataSourceIdForTrip: state.setDataSourceIdForTrip,
    }),
    shallow
  );
  const items = useMemo(() => (notifications ?? [])
    .filter((not) => !onlyUnread || !not.isVisited)
    .map((not) => ({
      id: not.id,
      message: not.message,
      authorName: not.createdByName,
      createdAt: moment(not.createdDate).toDate(),
      unread: !not.isVisited,
    })), [ notifications, onlyUnread ]);

  const openNotification = useCallback(({ id }) => {
    const not = notifications.find((n) => n.id === id);
    MarkAllAsReadHandler([ id ]);
    setOpenTripProfileView(true);
    setDataSourceIdForTrip(not?.entityId);
    setTripId(not?.tripId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ notifications ]);

  const toggleOnlyUnread = useCallback((unread) => {
    setOnlyUnread(unread);
    getNotifications(unread);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const markAllRead = useCallback(() => MarkAllAsReadHandler(),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ notifications, totalUnread ]);

  return (
    <NotificationMenu
      items={items}
      unreadCount={totalUnread}
      onlyUnread={onlyUnread}
      onToggleOnlyUnread={toggleOnlyUnread}
      onMarkAllRead={markAllRead}
      onItemClick={openNotification}
    />
  );
};

export default Notifications;
